import React from 'react';
import { CTAButton } from './CTAButton';
export function ResultsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-4 px-4" data-id="element-396">
      <div className="max-w-3xl mx-auto text-center" data-id="element-397">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-398">
          Tus clases de Educación Financiera no volverán a ser las mismas
        </h2>
        <CTAButton onClick={scrollToPricing} className="text-base px-6 py-3" data-id="element-399">
          → SÍ, QUIERO TRANSFORMAR MIS CLASES
        </CTAButton>
      </div>
    </section>;
}